module.exports = __webpack_public_path__ + "static/founder-be-c6404a29abc85e1b9cd31b8cc21bd64d.png";